<div class="dialog-header">
	<div class="header-title"><span style="font-size: 145%;">Change Password</span></div>
	
	<button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="edit-block">
	<form #passwordEditForm="ngForm" autocomplete="off" >
		<div class="form-block">

			<div class="form-row">
				<mat-form-field class="dialog-password-field"> <input autocomplete="off" matInput placeholder="Old Password" type="password" [required]="true" [(ngModel)]="oldPassword" name="oldPassword"></mat-form-field>
			</div>

			<div class="form-row">
				<mat-form-field class="dialog-password-field"> <input autocomplete="off" matInput placeholder="New Password" type="password" [required]="true" [(ngModel)]="newPassword"  name="newPassword"></mat-form-field>
			</div>

			<div class="form-row">
				<mat-form-field class="dialog-password-field"> <input autocomplete="off" matInput placeholder="Confirm Password" type="password" [required]="true" [(ngModel)]="confirmedPassword" name="confirmedPassword"></mat-form-field>
			</div>
			
		</div>

		<div *ngIf="showAlert" class="passwords-alert">{{alertText}}</div>

		<div class="save-btn-block">
			<button mat-button [disabled]="!passwordEditForm.form.valid" class="save-btn" (click)="saveAccountPassword()">Save</button>
		</div>
	</form>
</div>